import { render, staticRenderFns } from "./NewPasswordStep.vue?vue&type=template&id=66f0878c"
import script from "./NewPasswordStep.vue?vue&type=script&lang=js"
export * from "./NewPasswordStep.vue?vue&type=script&lang=js"
import style0 from "./NewPasswordStep.vue?vue&type=style&index=0&id=66f0878c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports